export default __webpack_public_path__ + "static/media/deleteTableIcon.2c352fd5.svg";